import { createSlice } from '@reduxjs/toolkit';

const parseQuestions = (QnA = {}) =>
    Object.keys(QnA)
        .filter(str => str.startsWith('q') && !str.includes('url'))
        .map(item => ({ question: QnA[item], audio: QnA[item + '_url'] }));

const mocks = createSlice({
    name: 'mock',
    initialState: {},
    reducers: {
        addMocks: (state, action) => {
            const formatted = {};
            action?.payload?.forEach(element => {
                formatted[element?.mock_id] = { ...element, questions: parseQuestions(element?.QnA) };
            });
            return formatted;
        },
        addMockDetail: (state, action) => {
            const mock = action.payload;
            state[mock.mock_id] = { ...state[mock.mock_id], ...mock, questions: parseQuestions(mock?.QnA) };
        },
    },
});

export const { addMocks, addMockDetail } = mocks.actions;
export default mocks.reducer;
